<script>
import Breadcrumb from '@/components/global/breadcrumb.vue';
import InputText from 'primevue/inputtext';
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import axios from "axios";
import Swal from "sweetalert2";
import Dropdown from 'primevue/dropdown';
import InputSwitch from 'primevue/inputswitch';
import FileUpload from 'primevue/fileupload';
import Button from 'primevue/button';
import InputNumber from 'primevue/inputnumber';
import { useGradeStore } from '@/stores/useGradeStore.js';

export default {
  name: "question-add",
  inject: {
    courseCtx: { default: null },
  },
  data() {
    return {
      v$: useVuelidate(),
      gradeSlug: this.$route.params.gradeSlug,
      courseId: this.$route.params.courseId ?? null,
      title: "",
      description: "", // Added
      fileData: null,
      link: "", // Added
      is_file: true, // Added
      formSending: false,
      lesson: null,
      lessons: [],
      unit: null,
      units: [],
      branch: null,
      branches: [],
      degree: null,
      type: 'mcq', // Fixed: was duplicated
      typeOptions: [
        { label: 'اختيار من متعدد', value: 'mcq' },
        { label: 'إجابة قصيرة', value: 'short_answer' }
      ],
      difficulty_level: 'easy',
      difficultyOptions: [
        { label: 'سهل', value: 'easy' },
        { label: 'متوسط', value: 'medium' },
        { label: 'صعب', value: 'hard' }
      ],
      answers: [
        { title: '', image: null, correct: false, question_id: null },
        { title: '', image: null, correct: false, question_id: null }
      ],
    };
  },
  components: {
    Breadcrumb,
    InputText,
    Dropdown,
    InputSwitch,
    FileUpload,
    Button,
    InputNumber
  },
  validations() {
    return {
      title: { required },
      degree: { required },
      // Add more validations as needed
    };
  },
  computed: {
    isCourseScope() { return !!this.courseId; },
    basePath() {
      return this.isCourseScope ? `/courses/${this.courseId}/question-bank` : `/${this.gradeSlug}/questions`;
    },
    breadcrumbs() {
      if (this.isCourseScope) {
        const base = this.courseCtx?.breadcrumbBase ?? [];
        return [...base, { name: "بنك الأسئلة", path: this.basePath }, { name: "إضافة سؤال", path: `${this.basePath}/add` }];
      }
      return [
        { name: 'الرئيسية', path: '/' },
        { name: "سؤال", path: this.basePath },
        { name: "إضافة سؤال", path: `/${this.gradeSlug}/question/add` },
      ];
    },
    gradeStore() { return useGradeStore(); },
    resolvedGrade() {
      const slug = this.gradeSlug;
      return this.gradeStore.activeGrades.find(g => g.slug === slug)
          || this.gradeStore.allGrades.find(g => g.slug === slug)
          || null;
    },
    gradeId() { return this.resolvedGrade?.id ?? null; },
    isMCQ() {
      return this.type === 'mcq';
    }
  },
  methods: {
    onFileChange(event) {
      if (event && event.target && event.target.files) {
        this.fileData = event.target.files[0];
      }
    },
    onAnswerImageChange(event, index) {
      if (event && event.files && event.files.length) {
        const file = event.files[0];
        this.answers[index].image = file;
        this.answers[index].imageName = file.name; // 👈 اسم الصورة
      }
    },

    addAnswer() {
      if (this.answers.length < 4) {
        this.answers.push({ title: '', image: null, correct: false, question_id: null });
      } else {
        Swal.fire({ icon: 'warning', title: 'Maximum answers reached', text: 'You can only add up to 4 answers.' });
      }
    },
    removeAnswer(idx) {
      if (this.answers.length > 2) {
        this.answers.splice(idx, 1);
      } else {
        Swal.fire({ icon: 'warning', title: 'لا يمكن الحذف', text: 'يجب أن يكون هناك إجابتين على الأقل.' });
      }
    },
    setCorrect(idx) {
      this.answers = this.answers.map((a, i) => ({
        ...a,
        correct: i === idx
      }));
    },
    sendForm() {
      this.v$.$validate();
      if (this.v$.$error) return;

      const formData = new FormData();
      formData.append('title', this.title);
      formData.append('description', this.description);
      formData.append('lesson_id', this.lesson?.id ?? this.unit?.id ?? this.branch?.id);
      formData.append('type', this.type);
      formData.append('difficulty_level', this.difficulty_level);
      formData.append('degree', this.degree);
      formData.append('is_file', this.is_file ? 1 : 0);

      if (this.is_file && this.fileData) {
        formData.append('image', this.fileData);
      }
      if (!this.is_file && this.link) {
        formData.append('link', this.link);
      }

      // Append answers if MCQ
      if (this.isMCQ) {
        this.answers.forEach((answer, idx) => {
          formData.append(`answers[${idx}][title]`, answer.title);
          formData.append(`answers[${idx}][correct]`, answer.correct ? 1 : 0);

          if (answer.image) {
            formData.append(`answers[${idx}][image]`, answer.image);
          }
        });
      }

      this.formSending = true;
      axios.post('/questions', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
          .then(() => {
            Swal.fire({ icon: "success", title: "تم الإضافة بنجاح" });
            this.resetForm();
            this.$router.push(this.basePath);
          })
          .catch((error) => {
            Swal.fire({ icon: "error", title: error.response?.data?.message || "حدث خطأ" });
          })
          .finally(() => {
            this.formSending = false;
          });
    },
    resetForm() {
      this.v$.$reset();
      this.title = "";
      this.description = "";
      this.type = 'mcq';
      this.difficulty_level = null;
      this.is_file = true;
      this.fileData = null;
      this.link = "";
      this.lesson = null;
      this.degree = null;
      this.answers = [
        { title: '', image: null, correct: false, question_id: null },
        { title: '', image: null, correct: false, question_id: null }
      ];
    },
    fetchBranch() {
      const params = this.isCourseScope
          ? { type: 1, course_id: this.courseId }
          : { type: 1, academic_year_id: this.gradeId };
      axios.get('/lessons', { params })
          .then(res => this.branches = res.data.data)
          .catch(() => this.branches = []);
    },
    fetchUnits() {
      if (!this.branch?.id) return;
      const params = this.isCourseScope
          ? { type: 2, course_id: this.courseId, parent_id: this.branch.id }
          : { type: 2, academic_year_id: this.gradeId, parent_id: this.branch.id };
      axios.get('/lessons', { params })
          .then(res => this.units = res.data.data)
          .catch(() => this.units = []);
    },
    fetchLessons() {
      if (!this.unit?.id) return;
      const params = this.isCourseScope
          ? { type: 3, course_id: this.courseId, parent_id: this.unit.id }
          : { type: 3, academic_year_id: this.gradeId, parent_id: this.unit.id };
      axios.get('/lessons', { params })
          .then(res => this.lessons = res.data.data)
          .catch(() => this.lessons = []);
    },
    customLabelBranch(option) { return option ? `${option.title} (${option.description})` : ''; },
    customLabelUnit(option) { return option ? `${option.title} (${option.description})` : ''; },
    customLabelLesson(option) { return option ? `${option.title} (${option.description})` : ''; },
  },
  async mounted() {
    if (!this.isCourseScope) {
      if (!this.gradeStore.activeGrades.length) await this.gradeStore.fetchActiveGrades();
      if (!this.gradeStore.allGrades.length) await this.gradeStore.fetchAllGrades();
    }
    this.fetchBranch();
  }
}
</script>

<template>
  <Breadcrumb :items="breadcrumbs" />
  <div class="form-page">
    <div class="form-page-header">
      <div class="form-page-header__icon">
        <i class="pi pi-question-circle"></i>
      </div>
      <div class="form-page-header__text">
        <h1 class="form-page-header__title">إضافة سؤال</h1>
        <p class="form-page-header__subtitle">إنشاء سؤال جديد وربطه بالمنهج الدراسي</p>
      </div>
    </div>

    <div class="container-fluid">
      <form @submit.prevent="sendForm()">
        <!-- Location hierarchy -->
        <div class="form-card">
          <div class="form-card__header">
            <div class="form-card__header-icon"><i class="pi pi-sitemap"></i></div>
            <span class="form-card__title">الموقع في المنهج</span>
          </div>
          <div class="form-card__body">
            <div class="row g-4">
              <div class="col-lg-4 col-md-6 col-12">
                <div class="form-field">
                  <label class="field-label">الفرع</label>
                  <Dropdown v-model="branch" :options="branches" showClear :optionLabel="customLabelBranch" placeholder="اختر الفرع" class="w-100" @update:model-value="fetchUnits" />
                </div>
              </div>
              <div class="col-lg-4 col-md-6 col-12">
                <div class="form-field">
                  <label class="field-label">الوحدة</label>
                  <Dropdown v-model="unit" :options="units" showClear :optionLabel="customLabelUnit" placeholder="اختر الوحدة" class="w-100" @update:model-value="fetchLessons" />
                </div>
              </div>
              <div class="col-lg-4 col-md-6 col-12">
                <div class="form-field">
                  <label class="field-label">الدرس</label>
                  <Dropdown v-model="lesson" :options="lessons" showClear :optionLabel="customLabelLesson" placeholder="اختر الدرس" class="w-100" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Question details -->
        <div class="form-card">
          <div class="form-card__header">
            <div class="form-card__header-icon"><i class="pi pi-pencil"></i></div>
            <span class="form-card__title">تفاصيل السؤال</span>
          </div>
          <div class="form-card__body">
            <div class="row g-4">
              <div class="col-12">
                <div class="form-field">
                  <label class="field-label">نص السؤال <span class="required">*</span></label>
                  <InputText id="title" v-model="title" placeholder="أدخل نص السؤال كاملاً" class="w-100" />
                  <span class="field-error" v-if="v$.title.$error">
                    <i class="pi pi-exclamation-circle"></i> برجاء ادخال نص السؤال
                  </span>
                </div>
              </div>
              <div class="col-lg-4 col-md-6 col-12">
                <div class="form-field">
                  <label class="field-label">نوع السؤال</label>
                  <Dropdown v-model="type" :options="typeOptions" disabled optionLabel="label" optionValue="value" class="w-100" />
                </div>
              </div>
              <div class="col-lg-4 col-md-6 col-12">
                <div class="form-field">
                  <label class="field-label">مستوى الصعوبة</label>
                  <div class="type-selector">
                    <label v-for="opt in difficultyOptions" :key="opt.value"
                      :class="['type-selector__item', { active: difficulty_level === opt.value }]">
                      <input type="radio" v-model="difficulty_level" :value="opt.value" class="d-none" />
                      {{ opt.label }}
                    </label>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-6 col-12">
                <div class="form-field">
                  <label class="field-label">درجة السؤال <span class="required">*</span></label>
                  <InputNumber id="degree" v-model="degree" :useGrouping="false" fluid placeholder="0" class="w-100" />
                  <span class="field-error" v-if="v$.degree.$error">
                    <i class="pi pi-exclamation-circle"></i> برجاء ادخال درجة السؤال
                  </span>
                </div>
              </div>
            </div>

            <!-- Image source toggle -->
            <div class="source-toggle mt-4">
              <i class="pi pi-image" style="color: var(--text-secondary);"></i>
              <span class="source-toggle__label">رفع صورة للسؤال</span>
              <InputSwitch v-model="is_file" />
              <span class="source-toggle__hint">{{ is_file ? 'رفع ملف صورة' : 'إدخال رابط خارجي' }}</span>
            </div>

            <div class="mt-3" v-if="is_file">
              <label class="field-label">الصورة <span class="optional">اختياري</span></label>
              <div :class="['upload-zone', { 'upload-zone--has-file': fileData }]">
                <div class="upload-zone__icon">
                  <i :class="`pi ${fileData ? 'pi-check' : 'pi-image'}`"></i>
                </div>
                <p class="upload-zone__label">{{ fileData ? fileData.name : 'اضغط لاختيار صورة' }}</p>
                <p class="upload-zone__hint" v-if="!fileData">PNG, JPG, GIF</p>
                <input type="file" @change="onFileChange" accept="image/*" />
              </div>
            </div>
            <div class="mt-3" v-else>
              <div class="form-field">
                <label class="field-label">رابط الصورة <span class="optional">اختياري</span></label>
                <InputText v-model="link" placeholder="https://..." class="w-100" dir="ltr" />
              </div>
            </div>
          </div>
        </div>

        <!-- MCQ Answers -->
        <div class="form-card" v-if="isMCQ">
          <div class="form-card__header">
            <div class="form-card__header-icon"><i class="pi pi-list-check"></i></div>
            <span class="form-card__title">خيارات الإجابة</span>
            <span style="margin-right: auto; font-size: 0.75rem; color: var(--text-muted); font-weight: 600;">{{ answers.length }} / 4</span>
          </div>
          <div class="form-card__body">
            <div v-for="(answer, idx) in answers" :key="idx" :class="['answer-item', { 'answer-item--correct': answer.correct }]">
              <div class="answer-item__index">{{ idx + 1 }}</div>
              <div class="answer-item__content">
                <InputText v-model="answer.title" placeholder="أدخل نص الإجابة" class="w-100" />
                <div v-if="answer.imageName" class="answer-item__image-tag">
                  <i class="pi pi-image"></i>
                  {{ answer.imageName }}
                  <button type="button" class="answer-item__remove-img" @click="answer.image = null; answer.imageName = ''">
                    <i class="pi pi-times"></i>
                  </button>
                </div>
              </div>
              <div class="answer-item__actions">
                <FileUpload
                  mode="basic"
                  accept="image/*"
                  :auto="true"
                  :multiple="false"
                  chooseIcon="pi pi-image"
                  chooseLabel=""
                  class="answer-img-upload"
                  @select="(e) => onAnswerImageChange(e, idx)"
                />
                <button type="button"
                  :class="['answer-correct-btn', { 'answer-correct-btn--active': answer.correct }]"
                  :title="answer.correct ? 'الإجابة الصحيحة' : 'تعيين كإجابة صحيحة'"
                  @click="setCorrect(idx)">
                  <i class="pi pi-check"></i>
                </button>
                <button type="button" class="answer-remove-btn" @click="removeAnswer(idx)" :disabled="answers.length <= 2">
                  <i class="pi pi-trash"></i>
                </button>
              </div>
            </div>

            <button type="button" class="add-answer-btn" @click="addAnswer" :disabled="answers.length >= 4">
              <i class="pi pi-plus"></i>
              إضافة إجابة جديدة
            </button>
          </div>
        </div>

        <div class="form-actions">
          <button type="submit" class="btn-submit" :disabled="formSending">
            <i class="pi pi-spin pi-spinner-dotted" v-if="formSending"></i>
            <i class="pi pi-check" v-else></i>
            {{ formSending ? 'جاري الإرسال...' : 'حفظ السؤال' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>